<template>
  <div id='bdialog' >

    <el-dialog v-loading='loading' class='gDia' :title="config.edit?$t('app_editver'):$t('app_addver')" v-model="isNewVer"  @close='verClose'>
      <div>
        <el-form>
          <el-form-item :label-width='widthps' :label="$t('app_version')">
            <el-input style='' v-model='vform.ver'></el-input>
          </el-form-item>
          <el-form-item :label-width='widthps' :label="$t('app_pubdate')">
            <el-date-picker
              v-model="vform.date"
              type="date"
              :format='yyyy-MM-dd'
              :picker-options="pickerOptions0"
              :placeholder="$t('app_select')">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label-width='widthps' :label="$t('app_updct')">
            <el-input
              type="textarea"
              :rows="5"
              v-model="vform.content">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="verClose">{{$t('app_cancel')}}</el-button>
        <el-button type="primary" @click="submitVer()">{{$t('app_sure')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog v-loading='loading' class='gDia' :title="config.edit?$t('app_editblt'):$t('app_addblt')" v-model="isNewBlt"  @close='bltClose'>
      <div>
        <el-form>
          <el-form-item :label-width='widthps' :label="$t('app_blttt')">
            <el-input style='' v-model='bform.title'></el-input>
          </el-form-item>
          <el-form-item :label-width='widthps' :label="$t('app_bltct')">
            <el-input
              type="textarea"
              :rows="7"
              v-model="bform.content">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bltClose">{{$t('app_cancel')}}</el-button>
        <el-button type="primary" @click="submitBlt()">{{$t('app_sure')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title=" getPre() + info.title"
      :visible.sync="isView"
      size="small"
      :before-close="viewClose">
      <div id="markdownBody" v-html='info.content'></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="viewClose">{{$t('app_sure')}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<style>

</style>

<script>
  // import tyc from '@/components/global/tyc'
  import mm from 'moment'
  export default{
    components: {
      
    },
    data () {
      return {
        pickerOptions0: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        info: {},
        loading: false,
        widthps: '22%',
        isNewVer: false,
        isNewBlt: false,
        isView: false,
        vform: {
          ver: '',
          date: '',
          content: ''
        },
        bform: {
          title: '',
          content: ''
        }
      }
    },
    props: [
      'config'
    ],
    watch: {
      /**推荐 */
      config () {
        //// 0 ver 1 blt 2 view
        if (!this.config) return
        if (this.config.type == 0) {
          // ver
          this.isNewVer = true
          if (this.config.edit)
          this.getVer()
        } else if (this.config.type == 1) {
          // bulletin
          this.isNewBlt = true
          if (this.config.edit)
          this.getBlt()
        } else {
          // view
          var config = this.config
          if (config.vinfo) {
            this.info = config.vinfo
          } else if (config.binfo) {
            this.info = config.binfo
          }
          this.isView = true
        }
      }
    },
    computed: {
      
    },
    methods: {
      getPre () {
        // if (!this.config.vtype) return ''
        var titles = [
          this.$t('app_verupdate'),
          this.$t('app_pltfblt')
        ]
        var index = this.config.vinfo?0:1 
        return '【' + titles[index] + '】'
      },
      getVer () {
        this.loading = true
        this.$udVerDetail(this.config.id, (res) => {
          this.loading = false
          if (res.status === 200) {
            // this.bform.title = res.data.noticeName
            // this.bform.content = res.data.noticeInfo
            this.vform.ver = res.data.version
            this.vform.date = mm(res.data.opetime)
            this.vform.content = res.data.memo
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = false
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      getBlt () {
        this.loading = true
        this.$bulletinDetail(this.config.id, (res) => {
          this.loading = false
          if (res.status === 200) {
            this.bform.title = res.data.noticeName
            this.bform.content = res.data.noticeInfo
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = false
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      submitVer () {
        if (!this.vform.date || !this.vform.ver || !this.vform.content) {
          this.$message(this.$t('app_inputCp'))
          return
        }
        var date = mm(this.vform.date).format('YYYY-MM-DD')
        // console.log(this.vform, date, mm(date)._d)

        this.loading = true
        if (this.config.edit) {
          this.$editUdVer(this.config.id, this.vform.ver, date, this.vform.content, (res) => {
            this.loading = false
            if (res.status === 200) {
              this.$message.success(res.message)
              this.verClose()
            } else {
              this.$message(res.message)
            }
          }, () => {
            this.loading = false
            this.$message.error(this.$t('app_rqsError'))
          })
        } else {
          this.$addUdVer(this.vform.ver, date, this.vform.content, (res) => {
            this.loading = false
            if (res.status === 200) {
              this.$message.success(res.message)
              this.verClose()
            } else {
              this.$message(res.message)
            }
          }, () => {
            this.loading = false
            this.$message.error(this.$t('app_rqsError'))
          })
        }

      },
      submitBlt () {
        if (!this.bform.title || !this.bform.content) {
          this.$message(this.$t('app_inputCp'))
          return
        }
        // console.log(this.bform)

        this.loading = true
        if (this.config.edit) { 
          this.$editBulletin(this.config.id, this.bform.title, this.bform.content, (res) => {
            this.loading = false
            if (res.status === 200) {
              this.$message.success(res.message)
              this.bltClose()
            } else {
              this.$message(res.message)
            }
          }, () => {
            this.loading = false
            this.$message.error(this.$t('app_rqsError'))
          })
        } else {
          this.$addBulletin(this.bform.title, this.bform.content,  (res) => {
            this.loading = false
            if (res.status === 200) {
              this.$message.success(res.message)
              this.bltClose()
            } else {
              this.$message(res.message)
            }
          }, () => {
            this.loading = false
            this.$message.error(this.$t('app_rqsError'))
          })
        }
      },
      viewClose () {
        this.isView = false
        var config = this.config
        if (config.vinfo && config.binfo) {
          this.config.vinfo = ''
          this.info = config.binfo
          this.isView = true
        } else if (config.callback) {
          config.callback()
        }
      },
      verClose () {
        this.isNewVer = false
        this.vform = {}
        if (this.config.callback) {
          this.config.callback()
        }
      },
      bltClose () {
        this.isNewBlt = false
        this.bform = {}
        if (this.config.callback) {
          this.config.callback()
        }
      },
    },
    mounted () {
      
    }
  }
</script>



// WEBPACK FOOTER //
// bdialog.vue?4b1835c0